import * as React from "react";
import {Component } from "react";
import "./navigation.scss";

import {NavigationConfiguration, NavigationItemConfiguration} from "../../../config/navigation-configuration";
import {UiState} from "../../../core/ui-state";
import {AppState} from "../app-mobx";
import {AppConfiguration} from "../../../core/config/app-configuration";
import SVG from "react-inlinesvg";
import rightArrow from "../../../assets/images/layout/right-arrow.svg";
import { Icon } from "../../../core/components/icon/icon";


export interface NavigationProps {
    config: NavigationConfiguration;
    handleNavigation: (route: string, topicId: string) => void;
    appConfig: AppConfiguration;
    appStore: AppState;
    uiStore: UiState;
}

export class Navigation extends Component<NavigationProps, any> {
    uiStore: UiState;
    constructor(props: NavigationProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }
    setSidebarVisible(sidebarVisible: boolean): void {
        this.uiStore.setSidebarVisible(sidebarVisible);
    }
    handleLocalUrl(event: React.MouseEvent, item: NavigationItemConfiguration): void {
        event.preventDefault();

        const {handleNavigation} = this.props;
        if (handleNavigation) {
            const route = (event.target as HTMLAnchorElement).pathname;
            handleNavigation(route, item.topicId || "");
        }
    }

    handleLogin(event: React.MouseEvent): void {
        const {appStore} = this.props;
        const {authentication} = appStore;
        if (appStore.loggedIn) {
            authentication.logout();
        } else {
            authentication.login().then((credential: __esri.Credential) => {
                appStore.setLoggedIn(true, credential);
            }).catch(() => {
                appStore.setLoggedIn(false);
            });
        }
    }


    render(): React.ReactElement | null {
        const {config, appConfig, appStore} = this.props;
        const {topic, subtopicId} = appStore;
        const naviItems: React.ReactElement[] = [];
        // const topicId = (topic) ? topic.id : "";
        let items: NavigationItemConfiguration[] = config.items;
        let backLink: React.ReactElement | null = null;
        const parentItem = config.items.find((item) => item.id === topic.id);
        if (subtopicId && parentItem
            && parentItem.sub
            && parentItem.sub.items.findIndex((item) => item.id === subtopicId) > -1) {
            // Sub navigation Notfallplanung
            items = parentItem.sub.items;
            if (parentItem.href) {
                let parentHref = parentItem.href;
                // prepend basename if local url
                if (/^\/(\w|$)/.test(parentItem.href)) {
                    parentHref = appConfig.basename + parentItem.href;
                    parentHref = parentHref.replace("//", "/");
                    backLink = (<a href={parentHref} className={"navigation__back-link"}
                        onClick={(event: React.MouseEvent) => this.handleLocalUrl(event, parentItem)}>
                        <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                        {parentItem.title}</a>);
                } else {
                    backLink = (<a href={parentHref} className={"navigation__back-link"}>
                        <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                        {parentItem.title}</a>);
                }
            }

        }
        items.forEach((element: NavigationItemConfiguration, index: number) => {
            let innerElement: React.ReactElement;
            const isSeparator = element.topicId === "separator";
            let addClass = "";
            if ([subtopicId, topic.id].includes(element.topicId)) {
                addClass = " current";
            }
            if (isSeparator) {
                addClass += " separator";
            }
            if (element.href) {
                let href = element.href;
                // prepend basename if local url
                if (/^\/(\w|$)/.test(element.href)) {
                    href = appConfig.basename + element.href;
                    href = href.replace("//", "/");
                    innerElement = (
                        <a href={href} target={element.target} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                            this.handleLocalUrl(event, element)}>{element.title}</a>
                    );
                } else {
                    innerElement = (
                        <a href={href} target={element.target}>{element.title}</a>
                    );
                }
            } else {
                if (isSeparator) {
                    innerElement = (
                        <div className="separator"></div>
                    );
                }
                // Einträge ohne Link welche nicht aktiv sind überspringen
                else if (element.id !== subtopicId) {
                    return;
                }
                else {
                    innerElement = (
                        <span>{element.title}</span>
                    );
                }
            }
            naviItems.push(
                <li className={"navigation__list-item" + addClass}
                    key={"navigation-" + index}>
                    {innerElement}
                </li>
            );
        });

        // login/logout
        const loginActive = [subtopicId, topic.id].includes("login") ? " current" : "";
        naviItems.push(
            <li className={"navigation__list-item" + loginActive} key={"navigation-" + (naviItems.length + 1)}>
                <a href={"/login"} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                    this.handleLogin(event)}>
                    <Icon name={appStore.loggedIn ? "log_out" : "log_in"} />
                    {appStore.loggedIn ? "Abmelden" : "Anmelden"}
                </a>
            </li>
        );
        return(
            <nav id="mainNav" className="layout__navigation">
                <div className="navigation home">
                    {backLink}
                    <ul className="navigation__list">
                        {naviItems}
                    </ul>
                </div>
            </nav>
        );
    }
}
